import { render, staticRenderFns } from "./CalendarInfoModal.vue?vue&type=template&id=2b4eaf95"
import script from "./CalendarInfoModal.vue?vue&type=script&lang=js"
export * from "./CalendarInfoModal.vue?vue&type=script&lang=js"
import style0 from "./CalendarInfoModal.vue?vue&type=style&index=0&id=2b4eaf95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports